/**
 * Boost icon URL
 * Malaysia's leading e-wallet platform
 * Source: Airwallex documentation
 * Used for payment method selection UI
 */
export const BOOST_ICON_DATA_URL =
  'https://www.airwallex.com/docs/assets/contentful/images.ctfassets.net/c3n7jozh84hr/1M4DBVFhOrkprPmjxZwS7M/c4a90840d3846b926d3a5524392435fe/Boost.svg';
